import React, { useState, useEffect } from "react";

// core components


// core components

// material-ui
import { makeStyles } from "@material-ui/core/styles";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const EstadisMoratorio = ({totalAmortizaciones}) => {

const useStyles = makeStyles(theme => ({
    ...dashboardStyle,
    root: {
      width: "100%"
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1)
    },
    actionsContainer: {
      marginBottom: theme.spacing(2)
    },
    resetContainer: {
      padding: theme.spacing(3)
    },
    rootRadio: {
      "&:hover": {
        backgroundColor: "transparent"
      }
    },
    icon: {
      borderRadius: "50%",
      width: 16,
      height: 16,
      boxShadow:
        "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
      backgroundColor: "#f5f8fa",
      backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
      "$root.Mui-focusVisible &": {
        outline: "2px auto rgba(19,124,189,.6)",
        outlineOffset: 2
      },
      "input:hover ~ &": {
        backgroundColor: "#ebf1f5"
      },
      "input:disabled ~ &": {
        boxShadow: "none",
        background: "rgba(206,217,224,.5)"
      }
    },
    checkedIcon: {
      backgroundColor: "#137cbd",
      backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
      "&:before": {
        display: "block",
        width: 16,
        height: 16,
        backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
        content: '""'
      },
      "input:hover ~ &": {
        backgroundColor: "#106ba3"
      }
    },
    cardIngresos: {
      fontWeight: "bold"
    },
    selectedRow: {
      backgroundColor: '#ffcccb', // Cambia el color de fondo de la fila seleccionada
    }
  }));
  const classes = useStyles();

  const [expandedRow, setExpandedRow] = useState(null);

  const handleRowClick = (index) => {
    if (index === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(index);
    }
  };


  return (
    <>
 <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitle}> Clientes Moratorios </h4>{" "}
        </CardHeader>{" "}
        <CardBody>
       
        <div>
  <TableContainer component={Paper}>
    <Table className={classes.table} aria-label="tabla colapsable">
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell>DESARROLLO</TableCell>
          <TableCell>MANZANA</TableCell>
          <TableCell>LOTE</TableCell>
          <TableCell>TOTAL MORATORIO</TableCell>
          <TableCell>MENSUALIDADES VENCIDAS</TableCell>
          <TableCell>NOMBRES</TableCell>
          <TableCell>APELLIDO PATERNO</TableCell>
          <TableCell>APELLIDO MATERNO</TableCell>
          <TableCell>CORREO</TableCell>
          <TableCell>TEL</TableCell>
          <TableCell>CELULAR</TableCell>

        </TableRow>
      </TableHead>
      <TableBody>
        {totalAmortizaciones.map((row, index) => (
          <React.Fragment key={index}>
            <TableRow 
            onClick={() => handleRowClick(index)}
            className={index === expandedRow ? classes.selectedRow : ''} // Aplica la clase de estilo si la fila está seleccionada    
            >
              <TableCell>
                {expandedRow === index ? (
                  <ExpandMoreIcon />
                ) : (
                  <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />
                )}
              </TableCell>
              <TableCell>{row.DESARROLLO}</TableCell>
              <TableCell>{row.MANZANA}</TableCell>
              <TableCell>{row.LOTE}</TableCell>
              <TableCell>{row.SUMATORIA_MONTOS}</TableCell>
              <TableCell>{row.MENSUALIDADES_VENCIDAS}</TableCell>
              <TableCell>{row.NOMBRES}</TableCell>
              <TableCell>{row.APELLIDO_PATERNO}</TableCell>
              <TableCell>{row.APELLIDO_MATERNO}</TableCell>
              <TableCell>{row.CORREO_ELECTRONICO}</TableCell>
              <TableCell>{row.TELEFONO_FIJO}</TableCell>
              <TableCell>{row.TELEFONO_MOVIL}</TableCell>

            </TableRow>
            {expandedRow === index && (
              <TableRow>
                <TableCell colSpan={12}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>AMORTIZACION</TableCell>
                          <TableCell>FECHA PAGO</TableCell>
                          <TableCell>MONTO ORIGINAL</TableCell>
                          <TableCell>ANTICIPO</TableCell>
                          <TableCell>FECHA ANTICIPO</TableCell>
                          <TableCell>MONTO INTERES</TableCell>
                          <TableCell>MONTO TOTAL</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.JTBL_AMORTIZACION.filter((amortizacion) => amortizacion.estatus === "M")
                        .map((amortizacion) => (
                          <TableRow key={amortizacion.id}
                          className={ classes.selectedRow}>
                            <TableCell>{amortizacion.id}</TableCell>
                            <TableCell>{amortizacion.fechaapagar}</TableCell>
                            <TableCell>{amortizacion.montoapagar}</TableCell>
                            <TableCell>{amortizacion.anticipado}</TableCell>
                            <TableCell>{amortizacion.fechapago}</TableCell>
                            <TableCell>{amortizacion.interes}</TableCell>
                            <TableCell>{amortizacion.moratorio}</TableCell>

                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</div>

  
  
        </CardBody>
      </Card>{" "}

        </>);
        };



        export default EstadisMoratorio;